// actions are functions that cause side effects and can involve
// asynchronous operations.
export default {
    contact({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.contact, params).then((response) => {

            if(response.data.status) {

            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },
    newsletterSubscribe({ commit, state }, params) {
        return this._vm.$http.post(this.getters.urls.api.newsletter.subscribe, params).then((response) => {

            if(response.data.status) {

            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });
    },
}